<template lang="pug">
button.ultimaAlteracao.Poppins(
  v-if="resumo",
  type="button",
  title="Ver histórico de alterações",
  @click.stop="$emit('click')"
)
  v-icon.ultimaAlteracao__icon(size="14") history
  span.ultimaAlteracao__texto
    | {{ resumo.acao }} {{ resumo.preposicao }}&nbsp;
    strong {{ resumo.autor }}
    span.ultimaAlteracao__quando  · {{ resumo.quando }}
</template>

<script>
import { resumirLog } from '@/util/logAtivacao';

export default {
  name: 'UltimaAlteracao',
  props: {
    log: { type: Object, default: null },
  },
  computed: {
    resumo() {
      return this.log ? resumirLog(this.log) : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.ultimaAlteracao {
  display: inline-flex;
  align-items: flex-start;
  gap: 5px;
  max-width: 100%;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  text-align: left;
  font-size: 11.5px;
  line-height: 1.4;
  color: #6B7280;

  &__icon {
    flex-shrink: 0;
    margin-top: 1px;
    color: #9CA3AF !important;
  }
  &__texto {
    min-width: 0;
    strong {
      color: #3A3A3A;
      font-weight: 600;
    }
  }
  &__quando {
    white-space: nowrap;
  }

  &:hover &__texto,
  &:focus-visible &__texto {
    text-decoration: underline;
  }
  &:focus { outline: none; }
  &:focus-visible {
    outline: 2px solid #3060CA;
    outline-offset: 2px;
    border-radius: 4px;
  }
}
</style>
